// Contact Table - Uses Unified Contact Selector
import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import CampaignTabHeader from '@extension/context/content/components/bt-bulk-dashboard/campaign-tab-header';
import { loadUserMessagesAndCampaignsThunk } from '@common/reducers/UserThunks';
import React, { FC, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';
import { UnifiedContactSelector } from '@extension/context/content/components/shared';
import { isExtensionContext } from '@common-services/detect-context';

export interface ContactTableProps {
    setImportedContacts?: React.Dispatch<React.SetStateAction<any[]>>
    importedContacts?: any[]
}

export const ContactTable: FC<ContactTableProps> = () => {
    const { t } = useTranslation(namespace)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const isExtension = isExtensionContext()

    useEffect(() => {
        dispatch(loadUserMessagesAndCampaignsThunk())
    }, [dispatch])

    // FE#305: on the web app, the "connect WhatsApp" empty-state CTA routes to the
    // connections page. In the extension the contacts come from the attached
    // WhatsApp Web tab (no /connections route in the campaigns memory router), so
    // the empty state shows the guidance text without the routing CTA.
    const handleConnectWhatsApp = useCallback(() => {
        navigate('/connections');
    }, [navigate]);

    return (
        <div className="flex flex-col flex-1 min-h-0 dir-ltr">
            <CampaignTabHeader
                title={t('importContacts.title')}
                subTitle=''
                className="flex-shrink-0"
            />
            <UnifiedContactSelector
                multiSelect
                showRefreshButton={!isExtension}
                showTypeFilter
                useReduxSelection
                height="100%"
                className="flex-1 px-4 pt-2"
                searchPlaceholder={t('importContacts.searchPlaceholder')}
                promptConnectWhenEmpty
                onConnectWhatsApp={isExtension ? undefined : handleConnectWhatsApp}
            />
        </div>
    );
};
